export default __webpack_public_path__ + "2816a7b7061b59cce2003052b5961d87.svg";